import ABI from './abi.json';

export const CONTRACT_ADDRESS = '0x2d5375E23dBcCaFB26b548f11a7d0b331C034b72';
export const CONTRACT_ABI = ABI;